export const loadTooltipBundle = () => (
    import('popper.js').then(() =>
        import ('bootstrap/js/dist/tooltip')
    )
);